class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification') || null;
    this.header = document.querySelector('sticky-header') || null;
    this.onBodyClick = this.handleBodyClick ? this.handleBodyClick.bind(this) : null;

    if (this.notification) {
      this.notification.addEventListener('keyup', (evt) => {
        if (evt?.code === 'Escape') this.close();
      });
    }

    try {
      this.querySelectorAll('button[type="button"]').forEach((btn) => {
        btn.addEventListener('click', this.close.bind(this));
      });
    } catch (e) {}
  }

  open() {
    if (!this.notification) return;
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener(
      'transitionend',
      () => {
        if (!this.notification) return;
        try {
          this.notification.focus?.();
          typeof trapFocus === 'function' && trapFocus(this.notification);
        } catch (e) {}
      },
      { once: true }
    );
    if (this.onBodyClick) {
      document.body?.addEventListener('click', this.onBodyClick);
    }
  }

  close() {
    if (!this.notification) return;
    this.notification.classList.remove('active');
    if (this.onBodyClick) {
      document.body?.removeEventListener('click', this.onBodyClick);
    }
    try {
      typeof removeTrapFocus === 'function' && removeTrapFocus(this.activeElement);
    } catch (e) {}
  }

  renderContents(parsedState = {}) {
    this.cartItemKey = parsedState?.key ?? null;
    const sectionsToRender = this.getSectionsToRender();
    if (!sectionsToRender.length) {
      this.header?.reveal?.();
      this.open();
      return;
    }
    sectionsToRender.forEach((section) => {
      const target = document.getElementById(section.id);
      if (!target) return;
      const htmlFromServer = parsedState?.sections?.[section.id];
      if (typeof htmlFromServer !== 'string') return;
      const inner = this.getSectionInnerHTML(htmlFromServer, section.selector);
      target.innerHTML = inner != null ? inner : htmlFromServer;
    });
    this.header?.reveal?.();
    this.open();
  }

  getSectionsToRender() {
    const knownIds = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
    return knownIds
      .filter((id) => document.getElementById(id))
      .map((id) => {
        let selector = undefined;
        if (id === 'cart-notification-product' && this.cartItemKey) {
          selector = `[id="cart-notification-product-${this.cartItemKey}"]`;
        }
        return { id, selector };
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    try {
      const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
      if (selector) {
        const node = doc.querySelector(selector);
        if (node) return node.innerHTML;
      }
      const defaultNode = doc.querySelector('.shopify-section');
      if (defaultNode) return defaultNode.innerHTML;
      return '';
    } catch (e) {
      return '';
    }
  }

  handleBodyClick(evt) {
    if (!this.notification) return;
    const target = evt?.target;
    if (!target) return;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest?.('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector?.('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element || null;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
